import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, input, Input, model, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl,FormsModule, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { IKit, ListQuest } from '../../../services/lists/list-quest';
import { ListGender } from '../../../services/lists/list-gender';
import { MatSelectModule } from '@angular/material/select';
import { TrainingMode } from '../../training/training-mode/training-mode';
import { PlayersService } from '../../../services/players/players';
import { AllStatus } from '../../../../core/services/status/all-status';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { FieldBuilder } from '../../../services/fields/field-builder';
import { ListRoles } from '../../../services/lists/list-roles';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitWaitingWindow } from '../../../dialogs/exit-waiting-window/exit-waiting-window';
import { ProgressPlayerHelper } from '../../../../features/progress-player/progress-player-helper';
import _ from 'lodash';
import { Subscription, take, timer } from 'rxjs';
import { Downtime } from '../../../../core/services/times/downtime';
import { NotificationService } from '../../../../core/services/Notification/notification';
import { A11yModule } from "@angular/cdk/a11y";
import { MatTooltip } from "@angular/material/tooltip";
import { InfoQuestRole } from '../../../dialogs/info-quest-role/info-quest-role';
import { DOCUMENT } from '@angular/common';
import { NgScrollbar, NgScrollbarModule } from 'ngx-scrollbar';
import { ClickableTooltip } from '../../../../features/directives/clickable-tooltip';
import { DifficultyLevel } from '../../../services/levels/difficulty-level';
import { RdGameService } from '../../../services/games/rd-game';
import { TariffsInfo } from '../../../dialogs/tariffs-info/tariffs-info';

interface ITypeGame{
  slug: string,
  name: string
}

@Component({
  selector: 'app-tmp-wt-player-info',
  imports: [TranslatePipe, MatFormFieldModule, TrainingMode,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule, A11yModule, MatTooltip,
  NgScrollbarModule,
ClickableTooltip],
  templateUrl: './tmp-wt-player-info.html',
  styleUrl: './tmp-wt-player-info.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TmpWtPlayerInfo implements OnInit{
  readonly dialog = inject(MatDialog);
  @ViewChild(NgScrollbar) private questListScrollbar?: NgScrollbar;
  
  player = model<any>();
  allPlayers = input<any>();
  selectType = input<any>();
  availableRQs = input<any>();
  maximumPlayers = input.required<number>();
 notification = inject(NotificationService);

 selectedValue:string = '';
//  selectedKit: number = 0;
 selectedKitValue: string = '';

  
  checked: boolean = false;
  isGoToFinish = signal(true);
  configuration = inject(ConfigurationService);
  fieldBuilder = inject(FieldBuilder);
  router = inject(Router);
  quests = inject(ListQuest);
  roles = inject(ListRoles);
  genders = inject(ListGender);
  players = inject(PlayersService);
  activatedRoute = inject(ActivatedRoute);
  allStatus = inject(AllStatus);
  progreshelper = inject(ProgressPlayerHelper);
  downtime = inject(Downtime);
  // private document = inject(Document);

  difficulty = inject(DifficultyLevel);

  typeGames: Array<ITypeGame> = [{
    slug: 'quest',
    name: "Квест"
  },{
    slug: "role",
    name: "Роль"
  }];
  isRole: boolean = false;
  isQuest: boolean = false;
  isExitGame: boolean = false;
  listLevels: Array<any> = [];
  checkedMentor = new FormControl(false);

  rdUse = inject(RdGameService);
  
  subscription: Subscription;
  subscriptionCL: Subscription;
  subscriptionDW: Subscription;
  subscriptionTm: Subscription;
  whenRefresh$ = timer(0, 1000);

  goal = signal('');
  goalDescr = signal('');
  translate = inject(TranslateService);
  txtDialog: any;

  listKits: Array<IKit> = [];
  //selectTypeGame: any;


  constructor( private ref: ChangeDetectorRef, @Inject(DOCUMENT) private document: Document){}

  form = new FormGroup({
    userName: new FormControl('',[Validators.required]),
    selectedGender: new FormControl(1, [Validators.required]),
    selectRole: new FormControl(1),
    selectQuest: new FormControl(101),
    selectedKit: new FormControl(1),
    selectTypeGame: new FormControl(),
    selectLevel: new FormControl(),
    isNewbie: new FormControl(true)
  });

  ngOnDestroy(){
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
    if(this.subscriptionDW){
      this.subscriptionDW.unsubscribe();
    }
    this.allStatus.setDisplayProgressSpinner(false);
  }

  ngOnInit(): void {
    this.isExitGame = false;
    
    this.allStatus.setLoadRQ(false);
    this.direction();
    this.isGoToFinish.set(true);
    this.loadTranslateText();
    if(this.isQuest){
      this.quests.quests = [];
      this.quests.getAllQuests();
    }

    if(this.isRole){
      this.roles.roles = [];
      this.roles.getAllRoles();
    }
    
    this.genders.loading();
    this.allStatus.isNewbie$.set(false);


    if(this.configuration.configuration.profile?.name){
      if(!this.validateEmail(this.configuration.configuration?.profile?.name)){
        this.form.get("userName")?.setValue(this.configuration.configuration.profile?.name);
      }      
    }

    if(this.configuration.configuration?.config?.i_am_tutor){
      this.update(this.configuration.configuration.config.i_am_tutor);
    }

    if(this.player().name !== "Player"){
      this.form.get("userName")?.setValue(this.player().name);
    }


    if(this.form.get("userName")?.value === ''){
      this.form.get("userName")?.setErrors({'required': true});
      this.form.get("userName")?.markAsTouched();
      this.ref.markForCheck();
    }    

    this.form.get("selectTypeGame")?.setValue(this.selectType());
    

    if(this.player().gender_id !== null){
      this.form.get("selectedGender")?.setValue(this.player().gender_id);
    }

    if(this.player().rq_id !== null){
      if(this.player().rq_id > 100){
        this.form.get("selectQuest")?.setValue(this.player().rq_id);
      }else{
        this.form.get("selectRole")?.setValue(this.player().rq_id);
      }
    }

    let boolQ: boolean = true;
    this.subscription = this.allStatus.selectRQ.subscribe(rqid =>{
      if(rqid){
        if(boolQ){
          
          boolQ = false;
          if(rqid > 99){
            this.form.get("selectQuest")?.setValue(rqid);
            this.selectQuestDefault(rqid);
          }else{
            this.form.get("selectRole")?.setValue(rqid);
            this.selectRoleDefault(rqid);
          }
        }
      }
    })

    this.subscriptionCL = this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.updateAllInfo();
        this.loadTranslateText();
        this.allStatus.setChangeLanguage(false);
        boolQ = true;
        setTimeout(()=>{
          
          if(this.subscriptionTm){
            
            this.subscriptionTm.unsubscribe();
          }
        }, 2500);
      }
    });
  
    this.form.get("isNewbie")?.setValue(this.player().is_newbie);

    this.form.get("isNewbie")?.valueChanges.subscribe( (x:any) =>{
      this.allStatus.isNewbie$.set(x);
    });


  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  updateAllInfo(){
    this.subscriptionTm = this.whenRefresh$.subscribe(()=>{
      this.ref.markForCheck();
    });
  }

   isMentor(){
    if( this.checkedMentor.value ){
      this.allStatus.setMentor(this.checkedMentor.value as boolean);
    }
  }

  changeGender(genderId: number):void{
    this.form.get("selectedGender")?.setValue(genderId);
  }

  changeLevel(level: number):void{
    this.form.get("selectLevel")?.setValue(level);
  }

  update(completed: boolean):void{
    this.checkedMentor.setValue(completed);
  }

  private validateEmail(email:string){
    return email.match( /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ );
  }

  setAll(completed: boolean){}

  direction(): void {
      switch(this.selectType()){
        case "quest": this.activeFieldQuest(); break;
        case "role": this.activeFieldRole(); break;
      }
      // Perform actions based on the new selected value
  }

  onRadioChange(event: MatRadioChange): void {
      switch(event.value){
        case "quest": this.activeFieldQuest(); break;
        case "role": this.activeFieldRole(); break;
      }
  }

  activeFieldRole(){
    this.isRole = true;
    this.isQuest = false;
    if(this.player().rq_id !== null){
      this.form.get('selectRole')?.setValue(this.player().rq_id);
    }
    this.form.get('selectRole')?.setValidators([Validators.required]);
    this.form.get('selectQuest')?.removeValidators(Validators.required);
    this.form.updateValueAndValidity();
  }

  activeFieldQuest(){
    this.isRole = false;
    this.isQuest = true;
    if(this.player().rq_id !== null){
      this.form.get('selectQuest')?.setValue(this.player().rq_id);
    }
    this.form.get('selectQuest')?.setValidators([Validators.required]);
    this.form.get('selectRole')?.removeValidators(Validators.required);
    this.form.updateValueAndValidity();
  }

  selectQuest(rq_id: number){
    this.form.get("selectQuest")?.setValue(rq_id);
    this.downtime.refreshTimer();
    this.allStatus.setSelectRQ(rq_id);
    this.quests.questInfo(rq_id).subscribe((answer:any)=>{
      if(this.player().is_starter){
        this.setSelectLevelForPlayerByArray(answer.quest.card_kits[0].difficulty_levels, answer.quest.card_kits[0].card_kit_id);
      }
      this.quests.quest = answer.quest;
      this.listKits = this.quests.quest.card_kits;
      this.form.get("selectedKit")?.setValue(this.listKits[0].card_kit_id);
      this.selectedKitValue = this.listKits[0].data.humman_description.title;
      this.selectedValue = answer.quest.data.humman_description.title;
      this.goal.set(answer.quest.data.humman_description.goal);
      this.goalDescr.set(answer.quest.data.humman_description.text);
    });
    this.quests.listRestructuring(rq_id);
    void this.questListScrollbar?.scrollTo({ top: 0 });
  }

  selectQuestDefault(rq_id: number){
    this.quests.questInfo(rq_id).subscribe((answer:any)=>{
      if(this.player().is_starter){
        this.setSelectLevelForPlayerByArray(answer.quest.card_kits[0].difficulty_levels, answer.quest.card_kits[0].card_kit_id);
      }
      this.allStatus.setDisplayProgressSpinner(false);
      this.quests.quest = answer.quest;
      this.listKits = this.quests.quest.card_kits;
      this.form.get("selectedKit")?.setValue(this.listKits[0].card_kit_id);
      this.selectedKitValue = this.listKits[0].data.humman_description.title;
      this.selectedValue = answer.quest.data.humman_description.title;
      this.goal.set(answer.quest.data.humman_description.goal);
      this.goalDescr.set(answer.quest.data.humman_description.text);
    });
  }

  selectRole(rq_id: number){
    this.form.get("selectRole")?.setValue(rq_id);

    this.downtime.refreshTimer();
    this.allStatus.setSelectRQ(rq_id);
    this.roles.roleInfo(rq_id).subscribe((answer:any)=>{
      if(this.player().is_starter){
        this.setSelectLevelForPlayer(answer.readrole.cards_by_difficulty);
      }
      this.selectedValue = answer.readrole.data.humman_description.title;
      this.goal.set(answer.readrole.data.humman_description.goal);
      this.goalDescr.set(answer.readrole.data.humman_description.text);
    });
  }

  selectRoleDefault(rq_id: number){
    this.roles.roleInfo(rq_id).subscribe((answer:any)=>{
      if(this.player().is_starter){
        this.setSelectLevelForPlayer(answer.readrole.cards_by_difficulty);
      }
      this.allStatus.setDisplayProgressSpinner(false);
      this.selectedValue = answer.readrole.data.humman_description.title;
      this.goal.set(answer.readrole.data.humman_description.goal);
      this.goalDescr.set(answer.readrole.data.humman_description.text);
    });
  }

  // 
  onSwitch($event: Event){
    $event.preventDefault();
    $event.stopPropagation();
    this.isMentor();
    this.downtime.refreshTimer();
    this.allStatus.textSpinner = this.txtDialog?.txtLobby;
    this.allStatus.setDisplayProgressSpinner(true);
    this.allStatus.isEditUserInWaiting = false;
    this.isGoToFinish.set(false);
    let listQ: Array<number> = [];
    let roleQuestId: number = 0;
    let role_icon: string = '';
    
    const infoGender = this.genders.findGender(this.form.get("selectedGender")?.value as number);
    
    if(this.form.get('selectTypeGame')?.value === 'role'){
      roleQuestId = this.form.get("selectRole")?.value as number;
      const infoRole = this.roles.findRole(this.form.get("selectRole")?.value as number);
      role_icon = infoRole.icon;      
      listQ = infoRole.data.questionnaire;      
    }

    if(this.form.get('selectTypeGame')?.value === 'quest'){
      // TODOD ще це потрібно this.form.get("selectQuest")?.value as number
      roleQuestId = this.form.get("selectQuest")?.value as number;
      const infoQuest = this.quests.findQuest(this.form.get("selectQuest")?.value as number);
      role_icon = infoQuest.icon;
      listQ.push(this.form.get("selectQuest")?.value as number);
    }
    
    this.fieldBuilder.userFillQuestField(listQ);
    
    this.player.set({...this.player(),
      rq_id: roleQuestId, 
      role_icon,
      name: this.form.get("userName")?.value,
      gender_id: infoGender?.gender_id,
      gender_icon: infoGender?.icon,
      gender_name: infoGender?.name,
      is_newbie: this.form.get("isNewbie")?.value as boolean,
      is_ready: true,
      quest_list: listQ,
      card_kit_id: this.form.get("selectedKit")?.value as number
      // quest_id: infoQuest.quest_id,
      // quest_name: infoQuest.name
    });

    if(this.player().is_starter){
      this.allStatus.setSelectLevel(this.form.get("selectLevel")?.value as number);
    }
    
    // TODO поки відключеться
    this.players.savePlayer(this.player(), this.activatedRoute.snapshot.paramMap.get('id') as string).subscribe({
      next: ()=>{
        const uuid = this.activatedRoute.snapshot.paramMap.get('id') as string;
        void this.rdUse.updatePlayerInGameById(this.player(), uuid).then(() =>{
          this.allStatus.setEditUserInWaiting(false);
          this.allStatus.isNewListVariant = true;
          this.router.navigate([`/lobby/${uuid}`]);
        }).catch((error: any) =>{
          this.allStatus.setDisplayProgressSpinner(false);
          this.isGoToFinish.set(true);
          this.notification.setMessage(error?.message ?? 'Failed to update player in the game');
          this.notification.display();
        });
      },
      error: err=>{
        this.allStatus.setDisplayProgressSpinner(false);
        this.isGoToFinish.set(true);
        this.notification.setMessage(err?.error?.message ?? err?.message ?? 'Failed to save player');
        this.notification.display();
      }
      
  });
  }


  windowExitGame($event: Event){
  $event.preventDefault();
  this.downtime.refreshTimer();
  const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(ExitWaitingWindow, dialogConfig);
    dialogRef.afterClosed().subscribe(result=>{
      if(result){
        this.isExitGame = true;
        if(this.player().is_starter){
          this.allStatus.textSpinner = this.txtDialog?.txtCanceling;
        }else{
          this.allStatus.textSpinner = this.txtDialog?.txtCancelKoop;
        }
        //this.allStatus.textSpinner = this.txtDialog?.txtCanceling;
        this.allStatus.setDisplayProgressSpinner(true); 
        this.onExitRoom();
      }
    });
  }

  onExitRoom(){

    this.quests.clearStorage();
    this.difficulty.clear();
    this.allStatus.clearNowCard();
    this.allStatus.clearExplanationTxt();
    this.allStatus.setChangeUuId('');
    this.allStatus.isEditUserInWaiting = false;

    if(this.player().is_starter){
      this.players.processDeletePlayersAndClosed(this.activatedRoute.snapshot.paramMap.get('id') as string, this.getAllPlayersId());
      this.players.detelePlayerStarter(this.activatedRoute.snapshot.paramMap.get('id') as string);
    }else{
      this.players.detelePlayer(this.activatedRoute.snapshot.paramMap.get('id') as string);
      setTimeout(()=>{
        window.location.assign('/games');
        // this.router.navigate(['/games']);
      },550);
    }

    
  }

  private getAllPlayersId(){
    let listId: Array<number> = [];
    this.allPlayers().forEach((item: any)=>{
      listId.push(item.player_id);
    });
    return listId;
  }

  

  setSelectLevelForPlayer(cardsByDifficulty: any){
    const difficulty: any = this.progreshelper.parseObjectToArrayGetBack(cardsByDifficulty);
    
    this.progreshelper.findType(difficulty[0].typeId);    
    //this.listOfAvailableRegions(difficulty);
    if(this.maximumPlayers() > 1){
      
      this.listOfAvailableRegions(difficulty,  difficulty[0].levels[difficulty[0].levels.length-1].level);
      this.form.get("selectLevel")?.setValue(difficulty[0].levels[0].level);
    }else{
      if(!_.isEmpty(this.progreshelper.progress)){        
        let isNotAllLevet: boolean = false;
        let lastLevel:number = 0  
        for( let i = 1; i <= difficulty[0].levels.length; i++ ){
          if( _.isEmpty(this.progreshelper.findLevel(i)) ){
            lastLevel = i;
            isNotAllLevet = true;
            break;
          }
        }
        if(!isNotAllLevet){
          this.listOfAvailableRegions(difficulty, difficulty[0].levels[difficulty[0].levels.length-1].level);
          this.form.get("selectLevel")?.setValue(difficulty[0].levels[difficulty[0].levels.length-1].level);
        }else{
          this.listOfAvailableRegions(difficulty, lastLevel);
          this.form.get("selectLevel")?.setValue(lastLevel);
        }    
          
      }else{
        this.listOfAvailableRegions(difficulty, difficulty[0].levels[0].level);
        this.form.get("selectLevel")?.setValue(difficulty[0].levels[0].level);
      }
    }
    

 
// Если в квесте N уровней из них прошли M, тогда предлагать начать с M+1 Уровня.
 
// Если пройдены все уровни, тогда дать возможность выбора любого. По умолчанию ставим последний Уровень.
  }

  listOfAvailableRegions(difficulty: any, activeLevel: number){
    this.listLevels = [];
    this.progreshelper.findType(difficulty[0].typeId);
  
    difficulty[0].levels.forEach((item: any) =>{
      if(item.level <= activeLevel){
        if(!_.isEmpty(this.progreshelper.findLevel(item.level))){
          // TODO якщо рівень пройдений то completed: true, якщо ні то false, 29.05.26 - true => false
          this.listLevels.push({ val:item.level, disabled: false, completed: false});
        }else{          
          this.listLevels.push({ val:item.level, disabled: false, completed: false});
        }
      }else{
        this.listLevels.push({val: item.level, disabled: true, completed: false});
      }      
    });
    
  }

  setSelectLevelForPlayerByArray(listLevel: Array<string>, typeId: number){
    this.progreshelper.findType(typeId);    
    //this.listOfAvailableRegions(difficulty);
    if(this.maximumPlayers() > 1){
      
      this.listOfAvailableRegionsArray(listLevel,  parseInt(listLevel[listLevel.length-1]), typeId);
      this.form.get("selectLevel")?.setValue(parseInt(listLevel[0]));
    }else{
      if(!_.isEmpty(this.progreshelper.progress)){        
        let isNotAllLevet: boolean = false;
        let lastLevel:number = 0  
        for( let i = 1; i <= listLevel.length; i++ ){
          if( _.isEmpty(this.progreshelper.findLevel(i)) ){
            lastLevel = i;
            isNotAllLevet = true;
            break;
          }
        }
        if(!isNotAllLevet){
          this.listOfAvailableRegionsArray(listLevel, parseInt(listLevel[listLevel.length-1]), typeId);
          this.form.get("selectLevel")?.setValue(parseInt(listLevel[listLevel.length-1]));
        }else{
          this.listOfAvailableRegionsArray(listLevel, lastLevel, typeId);
          this.form.get("selectLevel")?.setValue(lastLevel);
        }    
          
      }else{
        this.listOfAvailableRegionsArray(listLevel, parseInt(listLevel[0]), typeId);
        this.form.get("selectLevel")?.setValue(parseInt(listLevel[0]));
      }
    }
  }

  listOfAvailableRegionsArray(difficulty: any, activeLevel: number, typeId: number){
    this.listLevels = [];
    this.progreshelper.findType(typeId);
  
    difficulty.forEach((item: any) =>{
      if(parseInt(item) <= activeLevel){
        if(!_.isEmpty(this.progreshelper.findLevel(parseInt(item)))){
          // TODO якщо рівень пройдений то completed: true, якщо ні то false, 29.05.26 - true => false
          this.listLevels.push({ val:parseInt(item), disabled: false, completed: false});
        }else{          
          this.listLevels.push({ val: parseInt(item), disabled: false, completed: false});
        }
      }else{
        this.listLevels.push({val: parseInt(item), disabled: true, completed: false});
      }      
    });
    
  }

  showText(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    dialogConfig.data = {text: this.goalDescr()};
    const dialogRef = this.dialog.open(InfoQuestRole, dialogConfig);
  }

  showTariffs(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs-tariffs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(TariffsInfo,dialogConfig);
  }

  fnIsView():string{
    let elem: any = this.document.querySelector('.block-these-descr .description');
    setTimeout(()=>{
      this.ref.markForCheck();
    },200);
    return ( elem?.textContent.length as number <= 180 )?'hide-block':'show-block';
  }

  isCardKits():boolean{
    let isKits: boolean = false;
    if(this.configuration.configuration.config?.additional_card_kits){
      if(this.quests.quest?.card_kits?.length > 1){
        isKits = true;
      }
    }
    return isKits;
  }

  selectKit(cardKitId: number):void{
    this.selectedKitValue = '';
    this.quests.quest?.card_kits?.forEach((item: IKit)=>{
      if(item.card_kit_id === cardKitId){
        this.selectedKitValue = item.data.humman_description.title;
      }
    })
  }

}
